export default __webpack_public_path__ + "static/media/image09.cff68b43.jpg";